import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'

import { getBookingRules } from 'src/effects/ModifyDates/selectors'
import { resetStatusNewDatesAndPaxesAction, saveOfferAction } from 'src/effects/ModifyDates/actions'

import ModifyDatesDetails from 'src/comps/ModifyDates/ModifyDatesDetails'

import { SelectOfferBase, Title, BoardsWrapper, Header, DatesDetailsWrapper } from './styles'
import IconArrowDown from 'client/icons/ArrowDown'
import messages from './messages'

import ModifyDatesRoom from 'src/comps/ModifyDates/ModifyDatesRoom'

const SelectOffer = ({
  adults,
  children,
  childrenAges,
  checkIn = new Date(),
  checkOut = new Date(),
  existingBooking = {},
}) => {
  const dispatch = useDispatch()

  const bookingRules = useSelector(getBookingRules)

  const childrenAgesString = String(childrenAges)

  const selectedBooking = {
    checkIn,
    checkOut,
    adults,
    children,
    childrenAges: childrenAgesString,
    currency: existingBooking?.currency,
  }

  const totalFrom = bookingRules?.reduce(
    (min, board) => (board.sellingRate < min ? board.sellingRate : min),
    bookingRules[0]?.sellingRate || Infinity
  )

  function handleGoBack() {
    dispatch(
      resetStatusNewDatesAndPaxesAction({ checkIn, checkOut, adults, children, childrenAges })
    )
  }

  function saveSelectedOffer(board) {
    dispatch(saveOfferAction({ board }))
  }

  return (
    <SelectOfferBase>
      <Header>
        <Title>
          <FormattedMessage {...messages.selectOffer} />
        </Title>

        <DatesDetailsWrapper>
          <div>
            <ModifyDatesDetails
              booking={existingBooking}
              title="change-dates.original-dates-title"
              total
            />
          </div>
          <IconArrowDown />
          <div>
            <ModifyDatesDetails
              booking={selectedBooking}
              title="change-dates.new-dates-title"
              onClick={handleGoBack}
              totalFrom={totalFrom}
            />
          </div>
        </DatesDetailsWrapper>
      </Header>

      <BoardsWrapper>
        {bookingRules?.map((board, index) => {
          return (
            <ModifyDatesRoom
              room={board}
              bestPrice={index === 0}
              offerSelected={false}
              key={board?.availabilityId}
              onClick={() => saveSelectedOffer(board)}
              existingBooking={existingBooking}
            />
          )
        })}
      </BoardsWrapper>
    </SelectOfferBase>
  )
}

SelectOffer.propTypes = {
  adults: PropTypes.number,
  boards: PropTypes.instanceOf(Object),
  checkIn: PropTypes.instanceOf(Date),
  checkOut: PropTypes.instanceOf(Date),
  children: PropTypes.number,
  childrenAges: PropTypes.instanceOf(Array),
  sellingCurrent: PropTypes.number,
  existingBooking: PropTypes.instanceOf(Object),
  rooms: PropTypes.number,
}

export default SelectOffer
